import React from 'react'
import Module from '../../../layout/Module'
import { Routes, Route } from 'react-router-dom'
import General from './General/General'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'
import TabsLink from '../../../tabs/TabsLink'
import { useSelector } from 'react-redux'
import SSO from './SSO/SSO'
import Years from './Years/Years'
import AnalyticsChart from './AnalyticsChart/AnalyticsChart'
import AnalyticsDataRefresh from './AnalyticsDataRefresh/AnalyticsDataRefresh'
import Terms from './Terms/Terms'
import ApiServices from './ApiServices/ApiServices'
import Flags from './Flags/Flags'
import FeatureFlags from './FeatureFlags/FeatureFlags'
import ThirdPartyAccess from './ThirdPartyAccess/ThirdPartyAccess'

const isMaestroRole = (roles = []) => roles.some((r) => r?.id === 'Maestro')

const School = () => {
  const permission = useSelector((state) => state?.session?.permissions)
  const roles = useSelector((state) => state?.session?.user?.roles || [])
  const isMaestro = isMaestroRole(roles)

  return (
    <Module>
      <Module.Header title='School' titleLink={'/dashboard/school'} />
      <Module.Body>
        <Module.BodyHeader>
          <div className='relative overflow-hidden w-full h-full flex items-end'>
            <TabsLink
              id='school'
              items={[
                { id: 'general', name: 'General', path: '/dashboard/school', permission: true, end: true },
                {
                  id: 'sso',
                  name: 'SSO',
                  path: '/dashboard/school/sso',
                  permission: permission['sso'],
                  end: true
                },
                {
                  id: 'analytics-charts',
                  name: 'Analytics charts',
                  path: '/dashboard/school/analytics-charts',
                  permission: permission['analytics-chart'],
                  end: true
                },
                {
                  id: 'analytics-data',
                  name: 'Analytics data',
                  path: '/dashboard/school/analytics-data',
                  permission: permission['analytics-chart'],
                  end: true
                },
                {
                  id: 'terms',
                  name: 'Terms',
                  path: '/dashboard/school/terms',
                  permission: permission['term'],
                  end: true
                },
                {
                  id: 'years',
                  name: 'Years',
                  path: '/dashboard/school/years',
                  permission: permission['year'],
                  end: true
                },
                {
                  id: 'flags',
                  name: 'Flags',
                  path: '/dashboard/school/flags',
                  permission: permission['flag'],
                  end: true
                },
                {
                  id: 'api-services',
                  name: 'Api and services',
                  path: '/dashboard/school/api-and-services',
                  permission: permission['api-and-services'],
                  end: true
                },
                {
                  id: 'third-party-access',
                  name: 'Third party access',
                  path: '/dashboard/school/third-party-access',
                  permission: isMaestro || !!permission['third-party-access'],
                  end: true
                },
                {
                  id: 'feature-flags',
                  name: 'Feature Flags',
                  path: '/dashboard/school/feature-flags',
                  // MF-528 — seeder permission 'Feature-Flag' (assignable to other roles); Maestro
                  // fallback so it shows before the roles seeder update runs on existing tenants.
                  permission: isMaestro || !!permission['feature-flag'],
                  end: true
                }
              ]}
            />
          </div>
        </Module.BodyHeader>
        <Module.BodyContainer classNameWrapper='overflow-auto'>
          <Routes>
            <Route index element={<General />} />
            <Route path='sso' element={<SSO />} />
            <Route path='terms' element={<Terms />} />
            <Route path='years' element={<Years />} />
            <Route path='flags' element={<Flags />} />
            <Route path='analytics-charts' element={<AnalyticsChart />} />
            <Route path='analytics-data' element={<AnalyticsDataRefresh />} />
            <Route path='api-and-services' element={<ApiServices />} />
            <Route path='third-party-access' element={<ThirdPartyAccess />} />
            <Route path='feature-flags' element={<FeatureFlags />} />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </Module.BodyContainer>
      </Module.Body>
    </Module>
  )
}

export default School
